module.exports = __webpack_public_path__ + "img/application-integration.742cdbb8.png";